export type PrizmSliderValue = number | [number, number] | null;
export type PrizmSliderCnobValuePosition = 'top' | 'right' | 'bottom' | 'left';
export type PrizmSliderOrientation = 'horizontal' | 'vertical';
